module.exports = __webpack_public_path__ + "static/media/closeIcon.01970b97.svg";